import ModalBody from 'src/components/Modal/body'
import ModalFooter from 'src/components/Modal/footer'
import ModalHeader from 'src/components/Modal/header'
import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import { faClose } from '@fortawesome/pro-solid-svg-icons/faClose'
import Icon from '@hotmart/space-lib/dist/components/icon'
import { BlockCommentsModalProps } from './blockCommentsModal.types'
import { BlockCommentsLabels, UnblockCommentsLabels } from './blockCommentsModal.constants'
import { CustomCloseButton, CustomModal } from './blockCommentsModal.styles'
import useBlockComments from './hooks/useBlockComments/useBlockComments'

const BlockCommentsModal = ({
  isOpen,
  closeModal,
  isCommentsEnabled,
  postId
}: BlockCommentsModalProps) => {
  const { onConfirmButton, isLoading } = useBlockComments(closeModal)
  const labels = isCommentsEnabled ? BlockCommentsLabels : UnblockCommentsLabels

  return (
    <CustomModal show={isOpen} onClose={closeModal}>
      <ModalHeader className="_px-5 _pr-2 _pt-5 _pb-3">
        <div data-test="container-modal-block-comments" className="_d-flex">
          <h2 className="_flex-1 _text-4 _m-0 _text-gray-700">{i18n.t(labels.title)}</h2>
          <CustomCloseButton
            className="_d-flex _cursor-pointer _border-0 _bg-transparent _ml-3"
            onClick={closeModal}
            data-test="close-modal-button"
          >
            <Icon icon={faClose} className="_text-4 _text-gray-400" />
          </CustomCloseButton>
        </div>
      </ModalHeader>

      <ModalBody className="_px-5 _pb-5 _pt-0 _text-break">
        <p className="_text-2 _text-gray-500">{i18n.t(labels.description)}</p>
      </ModalBody>

      <ModalFooter className="_d-flex _justify-content-end _p-4">
        <Button
          variation="default"
          className="_border-0 _ml-4"
          onClick={closeModal}
          disabled={isLoading}
        >
          {i18n.t('buttons.cancel')}
        </Button>

        <Button
          variation="primary"
          className="_border-0 _ml-4"
          loading={isLoading}
          onClick={() =>
            onConfirmButton({ postId, isCommentsEnabled: isCommentsEnabled as boolean })
          }
        >
          {i18n.t(labels.confirmButton)}
        </Button>
      </ModalFooter>
    </CustomModal>
  )
}

export default BlockCommentsModal
